export default "__VITE_ASSET__BtXb1sGQ__"